import { useLink } from "@made-people/grease-link";
import { MenuTopLevelItem } from "./types";
import { useOldMenu } from "./old-menu-context";
import { useEffect, useState } from "react";

export const OldMenuLink = (
  props: MenuTopLevelItem & { className?: string },
) => {
  const Link = useLink();
  const { setActiveSubmenu, closeMenu } = useOldMenu();
  const { label, link, subMenu } = props;
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  useEffect(() => {
    setIsDesktop(window.innerWidth >= 1024);
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (subMenu && subMenu.length > 0 && !isDesktop) {
    return (
      <button
        className={`text-lg py-1.5 lg:text-base text-black text-left hover:underline underline-offset-4 flex justify-between ${props.className}`}
        onClick={() => setActiveSubmenu(props)}
      >
        {label}

        <svg
          data-v-50f8b942=""
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 8.8"
          className="w-3 h-3 -rotate-90"
        >
          <path
            data-v-50f8b942=""
            d="M15.86.9a.5.5 0 000-.7.49.49 0 00-.69 0L8 7.41.84.14a.5.5 0 00-.7 0A.54.54 0 000 .49a.5.5 0 00.14.35L8 8.8z"
          ></path>
        </svg>
      </button>
    );
  }

  return (
    <Link
      href={link?.href ?? ""}
      onClick={closeMenu}
      className={`text-lg py-1.5 lg:text-base text-black hover:underline underline-offset-4 ${props.className}`}
    >
      {label}
    </Link>
  );
};
